<script lang="ts">
    import { roomStore } from "../../../../stores/roomStore";
    import { closeCall } from "../../../../utils/closeCall";
    import CameraControls from "../Camera/CameraControls.svelte";

    $: room = $roomStore;

    function hangup() {
        console.log("[CameraCall] hangup");
        closeCall(room.id);
    }
</script>

{#if room}
    <div class="col-span-6 flex justify-center space-x-2 py-1">
        <CameraControls mode="hangup-only" onHangup={hangup} />
    </div>
{/if}
